import { ResultStatus, RunDetails, RunState } from "./types";

export const parseUtcDate = (s: string): Date =>
  new Date(s.endsWith('Z') || s.includes('+') ? s : s + 'Z');

export const MODULE_LABELS: Record<string, string> = {
  verkoop: "Verkoop Journaalposten",
  inkoop: "Inkoop Journaalposten",
  loon: "Loon Journaalposten",
  debiteuren: "Debiteuren",
  grootboeken: "Grootboeken",
  kostenplaatsen: "Kostenplaatsen",
};

export function getStatusColor(status: ResultStatus | null): "green" | "yellow" | "red" | "zinc" {
  switch (status) {
    case "SUCCESS": return "green";
    case "PARTIAL_SUCCESS": return "yellow";
    case "FAILED": return "red";
    case "CANCELLED": return "zinc";
    default: return "zinc";
  }
}

export const STAMGEGEVENS_CHANGED_FIELD_LABELS: Record<string, string> = {
  Code: "Code",
  Name: "Naam",
  City: "Plaats",
  Postcode: "Postcode",
  AddressLine1: "Adres",
  Status: "Status",
};

export function getStatusLabel(status: ResultStatus | null): string {
  switch (status) {
    case "SUCCESS": return "Geslaagd";
    case "PARTIAL_SUCCESS": return "Deels geslaagd";
    case "FAILED": return "Mislukt";
    case "CANCELLED": return "Geannuleerd";
    default: return "Bezig";
  }
}

export function getRunStateColor(state: RunState): "slate" | "zinc" | "primary" {
  switch (state) {
    case "RUNNING": return "primary";
    case "SCHEDULED": return "zinc";
    case "COMPLETED": return "slate";
    default: return "zinc";
  }
}

export function getRunStateLabel(state: RunState): string {
  switch (state) {
    case "RUNNING": return "Bezig";
    case "SCHEDULED": return "In wachtrij";
    case "COMPLETED": return "Uitgevoerd";
    default: return state;
  }
}

export function getUniqueJournaalpostLabel(count: number): string {
  return `${count} unieke ${count === 1 ? "journaalpost" : "journaalposten"}`;
}

export function getTotalSyncedCount(run: RunDetails): number {
  const moduleCount = [run.loonResult, run.inkoopResult, run.verkoopResult]
    .filter(Boolean)
    .reduce((sum, m) => {
      if (!m) return sum;
      const count = "processedRegelnummers" in m ? m.processedRegelnummers.length : m.processedPostnummers.length;
      return sum + count;
    }, 0);

  const stamgegevensCount = [run.debiteurenResult, run.grootboekenResult, run.kostenplaatsenResult]
    .filter(Boolean)
    .reduce((sum, m) => (m ? sum + m.createdCount + m.updatedCount + m.failedCount : sum), 0);

  return moduleCount + stamgegevensCount;
}

export interface ResultBadgeInfo {
  color: "green" | "yellow" | "red" | "zinc";
  label: string;
  title?: string;
}

export function getModuleResultBadge(status: ResultStatus | null, total: number): ResultBadgeInfo {
  if (status === "SUCCESS" && total === 0) {
    return {
      color: "green",
      label: "Geen wijzigingen",
      title: "Geslaagd, maar er is geen data gevonden om te synchroniseren",
    };
  }

  return { color: getStatusColor(status), label: getStatusLabel(status) };
}

export function getResultBadge(run: RunDetails): ResultBadgeInfo {
  return getModuleResultBadge(run.result, getTotalSyncedCount(run));
}

/** Time-of-day Dutch greeting. */
export const greeting = (hour = new Date().getHours()): string =>
  hour < 6 ? "Goedenacht" : hour < 12 ? "Goedemorgen" : hour < 18 ? "Goedemiddag" : "Goedenavond";
